import {
  Box,
  BrandImageComponent,
  BrandRequestEntity,
  Chevron,
  Div,
  H5,
  Icon,
  P,
  dateFormat,
  lightTheme,
} from '@vgrubs/components';
import { Link } from 'react-router-dom';

export const BrandVerificationComponent = ({
  brandVerification,
}: {
  brandVerification: BrandRequestEntity;
}) => {
  return (
    <Link to={`/verifications/brand/${brandVerification.id}`}>
      <Box $flex $between $alignCenter $mb="8">
        <Div $flex $gap="20px" $gapSM="12px" $alignCenter>
          <BrandImageComponent
            height={70}
            width={70}
            heightSM={50}
            widthSM={50}
            image={brandVerification.imageUrl}
          />
          <Div>
            <H5 $mb="4">{brandVerification.name}</H5>
            <P $mb="4">{brandVerification.location.name}</P>
            <Div $desktop>
              <P $m="0">
                <span>
                  Owner: {brandVerification.owner.firstName}{' '}
                  {brandVerification.owner.lastName}
                </span>{' '}
                <span style={{ color: lightTheme.lightGray }}>
                  | Date Requested: {dateFormat(brandVerification.createdAt)}.
                </span>
              </P>
            </Div>
            <Div $mobile>
              <P $m="0">
                <span>
                  Owner: {brandVerification.owner.firstName}{' '}
                  {brandVerification.owner.lastName}
                </span>{' '}
                <br />
                <span style={{ color: lightTheme.lightGray }}>
                  Date Requested: {dateFormat(brandVerification.createdAt)}.
                </span>
              </P>
            </Div>
          </Div>
        </Div>
        <Icon $rotate="90deg">
          <Chevron />
        </Icon>
      </Box>
    </Link>
  );
};
